// utils/itemFormData.ts

export interface ItemFormValues {
    item_name: string;
    item_sku: string;
    selling_price: number | string;
    purchase_price: number | string;
    web_per: number | string;
    system_per: number | string;
    regular_price: number | string;
    sale_price: number | string;
    quantity: number | string;
    gst: number | string;
    hsnId?: string;
    category: string;
    brand?: string;
    remarks?: string;
    tags?: string[];
    attributes?: Record<
        string,
        {
            attribute: string;
            manage_values_id: string;
            value: string;
        }
    >;
}

export function buildItemFormData(values: ItemFormValues, file?: File) {
    const formData = new FormData();

    // Scalars
    formData.append("item_name", values.item_name);
    formData.append("item_sku", values.item_sku);
    formData.append("selling_price", values.selling_price.toString());
    formData.append("purchase_price", values.purchase_price.toString());
    formData.append("web_per", values.web_per.toString());
    formData.append("system_per", values.system_per.toString());
    formData.append("regular_price", values.regular_price.toString());
    formData.append("sale_price", values.sale_price.toString());
    formData.append("quantity", values.quantity.toString());
    formData.append("gst", values.gst.toString());
    formData.append("category", values.category);

    if (values.hsnId) {
        formData.append("hsn_code", values.hsnId);
    }

    if (values.brand) {
        formData.append("brand", values.brand);
    }

    if (values.remarks) {
        formData.append("remarks", values.remarks);
    }

    // Tags → array-style
    // if (values.tags && values.tags.length > 0) {
    //     values.tags.forEach((tag, index) => {
    //         formData.append(`tags[${index}]`, tag);
    //     });
    // }
    formData.append("tags", JSON.stringify(values.tags))
    // formData.append("attributes", JSON.stringify(values.attributes))

    // Attributes → array of objects, array-style
    if (values.attributes && Object.keys(values.attributes).length > 0) {
        const attributesPayload = Object.values(values.attributes).map(attr => ({
            attribute_id: attr.attribute,
            manage_value_id: attr.manage_values_id,
        }));
        formData.append("attributes", JSON.stringify(attributesPayload));
    }


    // formData.append("attributes", JSON.stringify(values.attributes))

    // Image
    if (file instanceof File) {
        formData.append("image", file);
    }

    // Debug log
    // for (const [key, val] of formData.entries()) {
    //     console.log(key, val);
    // }

    return formData;
}
